import { render } from "./EditInPlace.vue?vue&type=template&id=f22c64ca&scoped=true"
import script from "./EditInPlace.vue?vue&type=script&lang=js"
export * from "./EditInPlace.vue?vue&type=script&lang=js"

import "./EditInPlace.vue?vue&type=style&index=0&id=f22c64ca&scoped=true&lang=css"

import exportComponent from "/var/www/html/nchsaet-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22c64ca"]])

export default __exports__